import { render, staticRenderFns } from "./BatchModifyAttribute.vue?vue&type=template&id=5212a839&scoped=true"
import script from "./BatchModifyAttribute.vue?vue&type=script&lang=js"
export * from "./BatchModifyAttribute.vue?vue&type=script&lang=js"
import style0 from "./batch-modify.css?vue&type=style&index=0&id=5212a839&prod&scoped=true&lang=css&external"
import style1 from "./BatchModifyAttribute.vue?vue&type=style&index=1&id=5212a839&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5212a839",
  null
  
)

export default component.exports